export var hrefAttr = function (_logger) { return ({
    shouldPreprocessNode: function (node) {
        return node.attribs && node.attribs['href'];
    },
    preprocessNode: function (node) {
        var attribValue = node.attribs['href'];
        if (/^javascript:/.test(attribValue)) {
            _logger.warn("Changed javascript:void to # on node ".concat(node.name));
            node.attribs['href'] = '#';
        }
        else {
            node.attribs['href'] = attribValue;
        }
    },
}); };
//# sourceMappingURL=hrefAttr.js.map